import { UserRight } from '@amzn/coral_com-amazon-asxcustomerprofileservice';

export interface ActionRequiredBannerState {
  isMissingBillingAddress: boolean;
  isUkVatUnverified: boolean;
  showBanner: boolean;
}

/**
 * Determines whether the action-required banner should be displayed based on user rights.
 * Banner shows only when billing address is missing (US + UK).
 * Note: UK_VAT_UNVERIFIED is tracked but does not trigger the banner.
 */
export const getActionRequiredBannerState = (
  isAuthenticated: boolean,
  userRights: UserRight[]
): ActionRequiredBannerState => {
  const isMissingBillingAddress = isAuthenticated && userRights.includes(UserRight.BILLING_ADDRESS_MISSING);
  const isUkVatUnverified = isAuthenticated && userRights.includes(UserRight.UK_VAT_UNVERIFIED);
  const showBanner = isMissingBillingAddress;

  return { isMissingBillingAddress, isUkVatUnverified, showBanner };
};
